module.exports = __webpack_public_path__ + "media/time-management_de_desktop.4dfa2a6f.webm";